module.exports = __webpack_public_path__ + "img/deck-the-halls-image.4e095915.jpg";